import { LOGIN_TYPE_TO_FRESH_LOGIN_METHOD, TFreshLoginCompletionMethod } from '@aca-new/app/pages/login/shared/constants/login-analytics.constants';
import { IUser } from '@aca-new/app/pages/user/shared/models/interfaces/user.interface';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { ELoginType } from '@aca-new/app/shared/models/enums/login-type.enum';
import { ISystemEvent } from '@aca-new/app/shared/models/interfaces/system-event.interface';
import { HttpService } from '@aca-new/app/shared/services/http-services/http.service';
import { AppAuthenticationService } from '@aca-new/app/shared/services/user-services/app-authentication/app-authentication.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// eslint-disable-next-line @typescript-eslint/naming-convention
import UAParser from 'ua-parser-js';

@Injectable({
  providedIn: 'root',
})
export class AppSystemEventService {
  public constructor(
    private readonly _httpService: HttpService,
    private readonly _appAuthenticationService: AppAuthenticationService
  ) {}

  public sendSystemEvent$(data: ISystemEvent): Observable<void> {
    return this._sendSystemEventByEndpoint$(data, '/v1.0/system-event');
  }

  public sendSystemEventForAnonymous$(data: ISystemEvent): Observable<void> {
    return this._sendSystemEventByEndpoint$(data, '/v1.0/system-event/spec');
  }

  private _sendSystemEventByEndpoint$(data: ISystemEvent, endpoint: string): Observable<void> {
    const userData: IUser = this._appAuthenticationService.getCurrentUser();
    const uaParser = new UAParser();
    const loginMethod = this._getLoginMethodFromSession();

    return this._httpService.httpClient
      .post<void>(
        `${SERVER_URL}${endpoint}`,
        {
          appName: 'myQima',
          os: JSON.stringify(uaParser.getOS() || ''),
          userId: userData.id,
          userName: userData.login,
          deviceName: JSON.stringify(uaParser.getDevice() || ''),
          ...data,
          login_method: loginMethod, // eslint-disable-line @typescript-eslint/naming-convention
          sourceId: data.sourceId || userData.id,
          dataJson: {
            ...data.dataJson,
            time: new Date().toISOString(),
            userAgentDetails: {
              ua: uaParser.getUA(),
              browser: uaParser.getBrowser(),
              engine: uaParser.getEngine(),
              cpu: uaParser.getCPU(),
            },
          },
        },
        { observe: 'body' }
      )
      .pipe(map((response: void): void => response));
  }

  /**
   * @returns {TFreshLoginCompletionMethod | undefined} Login method from session cookie.
   */
  private _getLoginMethodFromSession(): TFreshLoginCompletionMethod | undefined {
    const { loginType } = this._appAuthenticationService.getAuthenticationData();

    return LOGIN_TYPE_TO_FRESH_LOGIN_METHOD[loginType as ELoginType];
  }
}
